<template>
  <w-icon-wrapper
    :height="22.784"
    :width="22.824"
    view-box="0 0 22.824 22.784"
    icon-name="work-locked-icon"
  >
    <g
      id="_93_Gesperrt"
      data-name="93 Gesperrt"
      transform="translate(-274.296 -439.416)"
    >
      <g
        id="Gruppe_25625"
        data-name="Gruppe 25625"
        transform="translate(273.732 438.808)"
      >
        <path
          id="Pfad_55848"
          data-name="Pfad 55848"
          d="M14.529,23.392V19.6H.6v3.79h1.93V21.6h4.02v1.79h1.93V21.6H12.6v1.79Z"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4052"
          data-name="Rechteck 4052"
          width="6"
          height="6"
          transform="translate(5.564 12.274)"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4053"
          data-name="Rechteck 4053"
          width="3.765"
          height="3.765"
          transform="translate(0.564 14.51)"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4054"
          data-name="Rechteck 4054"
          width="2.006"
          height="2.006"
          transform="translate(12.56 16.268)"
          fill="currentColor"
        />
      </g>
      <path
        id="Pfad_55851"
        data-name="Pfad 55851"
        d="M21.768,5.108v-2c0-1.4-1.538-2.5-3.5-2.5s-3.5,1.1-3.5,2.5v2h-1.38v8h10v-8Zm-6-2c0-.813,1.145-1.5,2.5-1.5s2.5.687,2.5,1.5v2h-5Zm3.12,7.86v1.14h-1v-1.14a.984.984,0,0,1-.5-.86,1,1,0,1,1,2,0A.986.986,0,0,1,18.888,10.968Z"
        transform="translate(273.732 438.808)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconLocked' };
</script>
